import { t } from '@/features/i18n/utils';
import { useWorkspace } from '@/features/workspaces/helpers';
import { getDefaultStore } from 'jotai';
import { insightsMineAtom } from '@/features/insights/store';
import { insightsQuery } from '@/features/insights/queries';
import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceTypeIcon } from '@/features/workspaces/components/workspace-type-icon';
import { Breadcrumb, BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { Bookmark01Icon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';
import { InsightsPage } from '@/features/insights/components/insights-page';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/insights',
)({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.infiniteQuery({
      ...insightsQuery({
        workspaceId: params.workspaceId,
        savedBy: getDefaultStore().get(insightsMineAtom) ? context.auth.user.id : undefined,
      }),
      staleTime: 'static',
    }),
});

function RouteComponent() {
  const { projectId, workspaceId } = Route.useParams();
  const workspace = useWorkspace();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <Breadcrumb>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId"
            params={{ projectId, workspaceId }}
          >
            <WorkspaceTypeIcon type={workspace.type} />
            <span className="line-clamp-1">{workspace.name}</span>
          </BreadcrumbLink>
          <BreadcrumbPage>
            <Icon icon={Bookmark01Icon} />
            {t({ en: 'Saved findings', nb: 'Lagrede funn' })}
          </BreadcrumbPage>
        </Breadcrumb>
        <HeaderChatButton />
      </Header>
      <InsightsPage />
    </>
  );
}
